/**
 * JSR
 * e_produkt.js
 * JQuery funkce pro stránku produktu e-shopu
 *
 * @package eshop
 *
 * @author Jiří Chalupný <jchalupny@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.6.0
 */

$(document).ready(function() 
{
  var root = $( 'input#js_root' ).val(); 
  //prozkoumat všechny funkce stolu
  $('.sticky-wrapper .odkaz a').on('click', function (e) {
    e.preventDefault(); 
    $('div[data-url-old="popis"]').trigger('click');  
  });
  
  //<editor-fold defaultstate="collapsed" desc="Sticky práce mobil">

/* Sticky obrázkový blok na mobilu – v10
   = v8 (plynulé zmenšování vázané na scroll, žádné změny layoutu),
   jen s mírnějším zmenšením obrázku: COMPACT_SCALE určuje cílové měřítko
   a translateY drží obrázek vycentrovaný ve složené liště. */
(function () {
  const BAR_HEIGHT    = 200;  // výška plně složené lišty v px
  const COMPACT_SCALE = 0.8;  // měřítko obrázku ve složeném stavu (1 = nezmenšovat,
                              // menší číslo = větší oddálení; 0.8 ≈ mírné zmenšení)

  const $sticky = $('.produkt_celek_container .left-column-img');
  const $info   = $('.informace_produkt_celek');
  if (!$sticky.length) return;

  const mql = window.matchMedia('(max-width: 991px)');
  const $sentinel = $('<div class="lci-sentinel" aria-hidden="true"></div>').insertBefore($sticky);
  const sliderEl = document.getElementById('produkt_obrazek_slider');
  const el = $sticky[0];

  let enabled = false;
  let obsInfo = null;
  let resizeObs = null;
  let rafId = 0;
  let maxCut = 0;   // blockH - BAR_HEIGHT
  let tyMax  = 0;   // posun, aby střed zmenšeného slideru seděl na středu lišty

  function reloadSliderBX() {
    if (window.slider_bx && typeof window.slider_bx.reloadSlider === 'function') {
      window.slider_bx.reloadSlider();
    }
  }

  // rozměry: offsetHeight = layoutová výška, transform/clip ji neovlivní
  function computeVars() {
    if (!enabled) return;
    const sliderH = sliderEl ? sliderEl.offsetHeight : 0;
    maxCut = Math.max(0, el.offsetHeight - BAR_HEIGHT);
    tyMax  = BAR_HEIGHT / 2 - (sliderH * COMPACT_SCALE) / 2;
    update();
  }

  // průběžný stav podle scrollu – jen paint (clip + transform), žádný layout
  function update() {
    rafId = 0;
    if (!enabled) return;
    const slotTop = $sentinel[0].getBoundingClientRect().top;
    const cut = Math.min(Math.max(-slotTop, 0), maxCut);
    const p = maxCut > 0 ? cut / maxCut : (slotTop < 0 ? 1 : 0);

    el.style.setProperty('--lci-cut', cut.toFixed(1) + 'px');
    el.style.setProperty('--lci-scale-now', (1 - p * (1 - COMPACT_SCALE)).toFixed(4));
    el.style.setProperty('--lci-ty', (p * tyMax).toFixed(1) + 'px');

    // třída jen pro doplňky (skrytí mailing dialogu apod.), s malou hysterezí
    if (cut >= maxCut - 2) $sticky.addClass('is-sticky');
    else if (cut <= maxCut - 8) $sticky.removeClass('is-sticky');
  }

  function onScroll() {
    if (!rafId) rafId = requestAnimationFrame(update);
  }

  function enable() {
    enabled = true;
    document.documentElement.style.overflowAnchor = 'none';
    window.addEventListener('scroll', onScroll, { passive: true });
    computeVars();

    if ('ResizeObserver' in window) {
      resizeObs = new ResizeObserver(computeVars);
      resizeObs.observe(el);
      if (sliderEl) resizeObs.observe(sliderEl);
    }

    if ($info.length) {
      obsInfo = new IntersectionObserver(function (entries) {
        $sticky.toggleClass('sticky-off', entries[0].isIntersecting);
      }, { threshold: 0.1 });
      obsInfo.observe($info[0]);
    }
  }

  function disable() {
    enabled = false;
    document.documentElement.style.overflowAnchor = '';
    window.removeEventListener('scroll', onScroll);
    if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
    if (resizeObs) { resizeObs.disconnect(); resizeObs = null; }
    if (obsInfo) { obsInfo.disconnect(); obsInfo = null; }
    ['--lci-cut','--lci-scale-now','--lci-ty'].forEach(function (v) { el.style.removeProperty(v); });
    $sticky.removeClass('is-sticky sticky-off');
    reloadSliderBX(); // jen při přepnutí breakpointu
  }

  function onChange(e) { e.matches ? enable() : disable(); }
  onChange(mql);
  if (mql.addEventListener) mql.addEventListener('change', onChange);
  else mql.addListener(onChange);
})();


  
  /*const sticky = $('.produkt_celek_container .left-column-img');
  const infoElement = $('.informace_produkt_celek');
  const titulek = $('#header.titulek'); 

  let active = false;
  let blockedByInfo = false;
  let observerInfo = null;
  let observerTitulek = null;

  // BX slider reload helper
  function reloadSliderBX() { 
      if (window.slider_bx && typeof window.slider_bx.reloadSlider === 'function') {
          window.slider_bx.reloadSlider();
      }
  }
 
  function checkSticky() {
    if (!active || blockedByInfo) return;

    const rect = sticky[0].getBoundingClientRect();

    if (rect.top <= 10 && !sticky.hasClass('is-sticky')) {
 
        const heightBefore = sticky.outerHeight();
 
        sticky.addClass('is-sticky').removeClass('sticky-off');
        //$("#mailing_open_dialog").addClass("is-hidden");
 
        const heightAfter = sticky.outerHeight();
 
        const diff = heightBefore - heightAfter;
        if (diff !== 0) {
            window.scrollBy(0, diff);
        }

        reloadSliderBX();
    }
}

  // setup IntersectionObserver pro info blok
  function setupObserverInfo() {
      if (!infoElement.length) return;

      if (observerInfo) observerInfo.disconnect();

      observerInfo = new IntersectionObserver(entries => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  blockedByInfo = true;
                  sticky.addClass('sticky-off');
                  reloadSliderBX();
              } else {
                  blockedByInfo = false;
                  sticky.removeClass('sticky-off');
                  checkSticky();
              }
          });
      }, {threshold: 0.1});

      observerInfo.observe(infoElement[0]);
  }

  // setup IntersectionObserver pro titulek
  function setupObserverTitulek() {
      if (!titulek.length) return;

      if (observerTitulek) observerTitulek.disconnect();

      observerTitulek = new IntersectionObserver(entries => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  // Když se titulek objeví nad sticky, odebereme třídy
                  if (sticky.hasClass('is-sticky') || sticky.hasClass('sticky-off')) {
                      sticky.removeClass('is-sticky sticky-off');
                      //sticky.find('.fotogalerie').css({opacity: 1, pointerEvents: 'auto'});
                      //$( "#mailing_open_dialog" ).removeClass( "is-hidden" );
                      reloadSliderBX();
                  }
              }
          });
      }, {threshold: 0.1});

      observerTitulek.observe(titulek[0]);
  }

  // kontrola mobilního režimu
  function updateMode() {
      const isMobile = window.matchMedia('(max-width: 992px)').matches;

      if (isMobile && !active) {
          active = true;
          $(window).on('scroll', checkSticky);
          setupObserverInfo();
          setupObserverTitulek();
          checkSticky();
      } else if (!isMobile && active) {
          active = false;
          $(window).off('scroll', checkSticky);

          sticky.removeClass('is-sticky sticky-off');
          //sticky.find('.fotogalerie').css({opacity: 1, pointerEvents: 'auto'});
          //$( "#mailing_open_dialog" ).removeClass( "is-hidden" );
          reloadSliderBX();

          if (observerInfo) observerInfo.disconnect();
          if (observerTitulek) observerTitulek.disconnect();
      }
  }

  updateMode();
  $(window).on('resize', updateMode);
  $(window).on('load', updateMode);
  //funkce která na telefonu řeší mezeru v chrome pod price boxem který je sticky 
  function initStickyPriceBox() {
    if (!window.matchMedia('(max-width: 992px)').matches) return;

    const $sticky = $('.produkt_celek_container .price-box');
    const $parent = $('.produkt_celek_container');

    if (!$sticky.length || !$parent.length) return;

    let stickyHeight = $sticky.outerHeight();
    let isActive = false;

    function update() {
      const rect = $sticky[0].getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // sticky je přilepený ke spodku viewportu
      const isStickyNow = Math.round(rect.bottom) >= viewportHeight;

      if (isStickyNow && !isActive) {
        $parent.css('padding-bottom', stickyHeight + 'px');
        isActive = true;
      }

      if (!isStickyNow && isActive) {
        $parent.css('padding-bottom', '');
        isActive = false;
      }
    }

    function recalc() {
      stickyHeight = $sticky.outerHeight();
      update();
    }

    $(window).on('scroll resize', update);

    recalc();
  }

  initStickyPriceBox();*/
  
  //</editor-fold> 
  
  $( '#varianty' ).change(function() 
  { 
    $('#eshop_loading').removeClass( "hidden" );
    $.post( root + "/rsadmin/_funkce/eshop_varianty.php", {akce: "detail", id: this.value}, function( data ) 
    {
      var produkt = JSON.parse( data ); 
      window.history.replaceState(null, null, produkt.odkaz)
      $( '#nazev_produktu' ).html( produkt.nazev );
      $( '#eshop_udaje .kod' ).html( produkt.kod );
      $( '#eshop_udaje .cena' ).html( produkt.cena_vypis ); 
      $( '#eshop_udaje .cena_bez_dph' ).html( produkt.cena_bez_dph_vypis );
      $( '#eshop_udaje .dop_moc' ).html( produkt.cena_pred_vypis );
      $( '#dostupnost_vypis' ).removeClass().addClass( 'dostupnost dost' + produkt.dostupnost );
      var dostupnost = ( produkt.sklad > 10 ? ">10&nbsp;" + produkt.tj + " " : ( produkt.sklad > 0 ? produkt.sklad + "&nbsp;" + produkt.tj + " " : "" ) ) + produkt.dostupnost_vypis;
      $( '#dostupnost_text' ).html( dostupnost != "null" ? dostupnost : "" );
      $( '#dostupnost_ext' ).removeClass().addClass( 'dostupnost dost' + produkt.externi_dostupnost );
      if ( produkt.sklad > 0 ) $('#kdy_dostanu_zbozi').show();
      else $('#kdy_dostanu_zbozi').hide();
      var dostupnost_ext = ( produkt.externi_sklad > 0 ? produkt.externi_sklad + "&nbsp;" + produkt.tj + " " : "" ) + produkt.externi_dostupnost_vypis;
      $( '#dostupnost_ext' ).html( dostupnost_ext != "null" ? dostupnost_ext : "" );
      $( '#id_produktu' ).val( produkt.id );
      
      if( $( "#z_cena_bez_dph" ).val() == "1" )
        $( '#z_cena' ).val( produkt.cena_bez_dph );
      else
        $( '#z_cena' ).val( produkt.cena_vypis );
      
      //nastavení výběrů po změně varianty
      for( i = 0; i < produkt.vybery_produktu.length; i++ )
      { 
        var id_vyber = produkt.vybery_produktu[i].id; 
        for( j = 0; j < produkt.vybery_produktu[i].prvky.length; j++ )
        {
          var id_prvku = '#vyber_' + id_vyber + '_' + produkt.vybery_produktu[i].prvky[j].id; 
          if( !produkt.vybery_produktu[i].prvky[j].povolen )
          {
            $( id_prvku ).attr( "disabled", true );
          }
          else
          {
            $( id_prvku ).attr( "disabled", false );
          }
          if( produkt.vybery_produktu[i].typ == 1 ) $( id_prvku ).attr( "selected", false );
          else if( produkt.vybery_produktu[i].typ == 2 ) $( id_prvku ).attr( "checked", false );
        }
      }
      
      $('#eshop_loading').addClass( "hidden" );
    });
  });
  
  $( '.vyber_select, .vyber_checkbox' ).change( function()
  { 
    var limit = $('.vyber_nazev').attr("data-limit");
    if ($(this).attr("type") === "checkbox" && limit > 0)
    {
      if ($('.vyber_checkbox:checked').length > limit)
      {
        this.checked = false;
        return;
      }
    }
    
    var cena = parseInt( $( '#z_cena' ).val() ); 
    $('.vyber_checkbox:checked').each(function () {
      
        cena = parseInt( cena + parseInt( $(this).attr("data-price") ) );
       
    });
     
    $(".vyber_select").each(function () { 
      $(this).children("option:selected").each(function () {
        
          cena = parseInt( cena + parseInt( $(this).attr("data-price") ) );
        
      });
    });
     
    if( $( "#z_cena_bez_dph" ).val() == "1" )
    {  
      $( "#cena" ).html( formatujCenu( cena * ( 1 + parseInt( $( "#dph" ).val() ) / 100 ) ) );
      $( "#cena_bez_dph" ).html( formatujCenu( cena ) );
    }
    else
    {
      $( "#cena" ).html( formatujCenu( cena ) );
      $( "#cena_bez_dph" ).html( formatujCenu( cena / ( 1 + parseInt( $( "#dph" ).val() ) / 100 ) ) );
    }
  });
   
  $('.vybery_produkt img[title]').tooltip(
  {
    tooltipClass: "tooltip",
    content: function () { return $(this).prop('title'); }
  });
    
  $( '#form_koupit' ).submit( function() 
  {    
    if( $( '#id_produktu' ).val() == $( "#varianta_prvni" ).val() ){
      $( "#nelze_objednat" ).dialog({
        width: 400,
        height: 'auto',
        modal: true,
        buttons: { 
            OK: function(){ 
                $( this ).dialog( "close" );
            }
        }
      });
      return false;
    }
    if( $('.vyber_nazev').length > 0 )
    {
      var limit = $('.vyber_nazev').attr("data-limit");
      if(/*$('.vyber_checkbox:checked').length < limit || */$('.vyber_checkbox:checked').length <= 0)
      {
         alert($('#text_vyberte_chyba').val());
         return false;
      }   
    }
    this.submit();
    return true;
  });
  
  $( '#form_hodnoceni' ).submit( function(e) 
  {   
    $.each( $( '#form_hodnoceni .form_image' ), function (key, value) {  
      if( value.files[0].name !== "" )
      { 
        var fileSize = value.files[0].size;
        var maxSize = 5 * 1024 * 1024; // 5MB
        if (fileSize > maxSize) 
        {
          alert( $( '#form_hodnoceni #fotogalerieChyba' ).val().replace( '%s', ( parseInt(key) + 1 ) ) ); 
          e.preventDefault();
          return false;
        }
      } 
    }); 
     
    return true;
  });
  
  //<editor-fold defaultstate="collapsed" desc="Donačtení zbylých dotazů poradny / hodnocení">

  var nacitaniZaznamu = {};

  /**
   * Donačte zbylá hodnocení nebo dotazy poradny v detailu produktu.
   * @param {jQuery} tlacitko tlačítko s atributy data-typ, data-id, data-od
   * @returns {Promise} splní se po vložení záznamů (nebo hned, pokud není co načítat)
   */
  function nactiZbyleZaznamy( tlacitko )
  {
    if ( tlacitko.length <= 0 ) return $.Deferred().resolve().promise();
    var typ = tlacitko.attr( "data-typ" );
    if ( nacitaniZaznamu[typ] ) return nacitaniZaznamu[typ];

    //během načítání zobrazím na tlačítku loading (stejně jako v konfigurátoru)
    tlacitko.addClass( "loading" );

    nacitaniZaznamu[typ] =$.getJSON( root + "/rsadmin/_funkce/eshop_produkt_dalsi.php", { typ: typ, id: tlacitko.attr( "data-id" ), od: tlacitko.attr( "data-od" ) } )
      .done( function( data ) {
        var nove = $( $.parseHTML( $.trim( data.html ) ) );
        tlacitko.parent().before( nove ).remove();
        //nově vložené prvky potřebují inicializovat galerie a tooltipy (jinak se inicializují jen při načtení stránky)
        nove.find( ".fotogalerie" ).each( function() { initGalerie( this ); });
        nove.find( ".info_tool" ).tooltip({ position: { my: "center bottom", at: "right top" }, content: function() { return $( this ).attr( "title" ); } });
      })
      .fail( function() {
        tlacitko.removeClass( "loading" );
        delete nacitaniZaznamu[typ];
      });
    return nacitaniZaznamu[typ];
  }

  $( "#komentare_nacist, #hodnoceni_nacist" ).click( function() { nactiZbyleZaznamy( $( this ) ); return false; });

  /**
   * Nastaví filtr hodnocení – pokud nejsou načtena všechna hodnocení, nejdřív je donačte.
   * @param {jQuery} odkaz vybraný odkaz filtru
   * @param {string|null} trida třída zobrazených hodnocení, null = všechna
   * @returns {void}
   */
  function filtrujHodnoceni( odkaz, trida )
  {
    $( ".hodFiltr a" ).removeClass( "vybrany" );
    odkaz.addClass( "vybrany" );
    nactiZbyleZaznamy( $( "#hodnoceni_nacist" ) ).done( function() {
      if ( trida === null ) $( ".hodnoceni_texty .kom" ).show();
      else
      {
        $( ".hodnoceni_texty .kom" ).hide();
        $( ".hodnoceni_texty ." + trida ).show();
      }
    });
  }

  $( "#hodFiltrFotogalerie" ).click( function(){ filtrujHodnoceni( $( this ), "kom_fotogalerie" ); });
  $( "#hodFiltrTyp1" ).click( function(){ filtrujHodnoceni( $( this ), "kom_typ1" ); });
  $( "#hodFiltrVse" ).click( function(){ filtrujHodnoceni( $( this ), null ); });

  /**
   * Zobrazí zadaný komentář poradny (např. po odpovědi nebo z odkazu v e-mailu) – rozbalí nadřazená vlákna a odscrolluje na něj.
   * @param {string} id ID komentáře
   * @returns {void}
   */
  function zobrazKomentar( id )
  {
    var text = $( "#komText" + id );
    if ( text.length <= 0 ) return;

    //rozbalím vlákna stejně jako klik na komentář v komentare.js
    text.parents( ".comm_celek_chidren" ).each( function() {
      $( this ).parent( "div" ).children( ".comm_celek_chidren" ).show().addClass( "open_komentar_children" );
      $( this ).parent( "div" ).children( ".komentar" ).addClass( "open_komentar" );
    });

    $([document.documentElement, document.body]).animate({
      scrollTop: text.closest( ".komentar" ).offset().top - 200
    }, 200);
  }

  //</editor-fold>
  
  $('#kdy_zbozi_dostanu_odkaz').click( function() 
  {
    $('#kdy_zbozi_dostanu').dialog({
      resizable: false,
      height: "auto",
      width: 700,
      modal: true,
      buttons: {
        "Zavřít": function() {
          $( this ).dialog( "close" );
        },
      }
    });
  }); 
    
  $( '#setProduktOblibene' ).click(function() {
      var stav = $(this).attr('rel');
      
      $.ajax({
        url: '/rsadmin/_funkce/eshop_oblibene_produkty.php',        
        type: "GET",
        dataType: "html",       
        cache: false,        
        data: {id_produktu: $(this).attr('date-id'), stav: stav},          
        success: function(aData) { 
            if (stav=='0') {
                $("#imgStar").attr('src', "/images/star_ne.png");
                $("#setProduktOblibene").attr('rel', "1");
            }            
            else {
                $("#imgStar").attr('src', "/images/star_ano.png");   
                $("#setProduktOblibene").attr('rel', "0");
            }
        }
      });
  });  
  
  
  
//  $(".informace_vybery div").each(function (index) {
//    if(index == 0)
//    {  
//      $( this ).addClass( "info_vybrany" );
//      $("#"+$( this ).attr('data-show')).removeClass('hide_produkt');
//    }
//  });
  
  /*$( '.info_uproduktu' ).click(function() {
    $(".informace_vybery div").each(function (index) {    
        $( this ).removeClass( "info_vybrany" );
        $("."+$( this ).attr('data-show')).addClass('hide_produkt');
    });
    
    $( this ).addClass( "info_vybrany" );
    $("."+$( this ).attr('data-show')).removeClass('hide_produkt'); 
    window.location.hash="#"+$( this ).attr('data-url');
    $("html, body").animate({scrollTop:$( this ).offset().top-200},100);
  });*/
  
  $('.info_uproduktu').click(function() { 
    $(".informace_vybery div").each(function() {
      $(this).removeClass("info_vybrany");
      $("." + $(this).attr('data-show')).addClass('hide_produkt');
    });
 
    $(this).addClass("info_vybrany");
    const targetClass = $(this).attr('data-show');
    $("." + targetClass).removeClass('hide_produkt');
 
    window.location.hash = "#" + $(this).attr('data-url');
 
    // najdeme pozici aktivního tabu
    const stickyOffset = $('.informace_produkt_celek').outerHeight() || 100; // výška sticky hlavičky
    const targetTop = $("." + targetClass).offset().top - stickyOffset - $('header').outerHeight() || 0; // ← tady ta rezerva 100px
 
    $('html, body').animate({ scrollTop: targetTop }, 250);
  });
  
  
      $('.produkt_dotazy_tab_celek div div').click(function () {


        if ($(this).children('p').attr('class') !== 'show')
        {


            $(this).children('p').slideDown("slow", function () {

            });
            $(this).children('p').addClass('show');
            $(this).addClass('open_produkt');

        } else
        {

            $(this).children('p').slideUp("slow", function () {

            });
            $(this).children('p').removeClass('show');
            $(this).removeClass('open_produkt');

        }

    });

    $(".produkt_dotazy_tab div div em").mouseenter(function () {

        $(this).closest('div').addClass("open_faq_produkt");
    });
    $(".produkt_dotazy_tab div div em").mouseleave(function () {

        $(this).closest('div').removeClass("open_faq_produkt");

    });
    
    const isMobile = window.matchMedia('(max-width: 992px)').matches;
    
    window.slider_bx = $('#produkt_obrazek_slider').bxSlider({
      mode: 'fade',
      speed: 0,
      infiniteLoop: true,
//    captions: true,
      controls: true,
      touchEnabled: isMobile,//swipe nefunguje na iOs a ve chrome blbne - nefungují eventy - klik probíhá jakoby na hlavní prvek slideru
      keyboardEnabled: false //původně true
//    preloadImages: 'all'  
    });
//    var slider_li = $('#eshop_obrazek_slider-li').bxSlider({
//      mode: 'fade',
//      speed: 0,
//      infiniteLoop: true,
////    captions: true,
//      controls: true,
//      touchEnabled: true,
//      adaptiveHeight: true,
//      preloadImages: 'all',
//      captions:true
//    });
    
    $(document).on('click', '.ui-widget-overlay', function () {
      $("div:ui-dialog:visible").dialog("close");
      $('body').css('overflow', '');
    }); 
    
    $( ".open_galery" ).click(function ()
    {  
      $( ".fotka_" + $( this ).attr( "data-slide" ) +  " a" )[0].click(); 
    });
    $( ".slider_u_produktu img" ).click(function ()
    {     
      $( ".left-column-img .fotka_" + $( this ).parent().parent().attr( "data-slide" ) + " a" )[0].click(); 
    });
//    $( "#zvetsit" ).click(function ()
//    {
//      $( ".fotka_" + $( ".slider_u_produktu:visible" ).attr( "data-slide" ) + " img" ).click(); 
//    });
    //pokud klikne člověk do marginu obrázku, musí se také otevřít
    /*$( ".slider_u_produktu_dorovnani" ).click(function ()
    {  
      //$( this ).find( "img" ).click(); 
      if( $( ".simple-lightbox" ).length <= 0 )
        $( ".fotka_" + $( ".slider_u_produktu:visible" ).attr( "data-slide" ) + " img" ).click();
    });*/
    
    $( "#hodnoceni_foto" ).click(function(){
      $( "#info_hodnoceni" ).click();
      $( "#hodFiltrFotogalerie" ).click();
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".produkt_hodnoceni_tab").offset().top-200
      }, 200);
      
      return false;
    });
     
  // Garance ceny   
  $('#garance_cena').click(function ()
  {

    $('body').css('overflow', 'hidden');
    $(document).scrollTop();
    var windowWidth = $(window).width();
    $("#garance_cena_dialog").dialog({
      resizable: true,
      width: ( windowWidth <= 600 ? windowWidth - 50 : "60%" ),
      modal: true,
      closeText: "",
      dialogClass: "dialog_web",
      beforeClose: function () {
        $('body').css('overflow', '');
      },
      buttons: {
        "Zavřít": function () {
          $('body').css('overflow', '');
          $(this).dialog("close");
        }
      }
    });
  });
  $(document).on('keyup', function(e) {
    if (e.key === 27 ) $("#garance_cena_dialog").dialog("close");
  });
  
  $('form#emailGarance').submit( function(e)
  {      
    if ( $(this).hasClass( 'already-submitted' ) )
    {
      e.preventDefault();
      return false;
    }
    else
    {
      if(!KontrolaFormular())
      {
         return false;    
      }  
      $(this).addClass( 'already-submitted' );
      return true;
    }
  });

  $('#open_prodejny').click(function ()
  { 
    var windowWidth = $(window).width();
    $("#open_prodejny_form").dialog({
      resizable: true,
      width: ( windowWidth <= 992 ? windowWidth - 50 : "50%" ),
      modal: true,
      closeText: "",
      dialogClass: "dialog_web",
      open: function() {
        $( "#open_prodejny_close" ).click(function(){ 
          $("#open_prodejny_form").dialog("close");
        });
      },
      beforeClose: function () { },
      buttons: {
        "Zavřít": function () { 
          $(this).dialog("close");
        }
      }
    });
    return false;//aby se nevložil hash do url
  });
  
  /*  
  $('#zvetsit, .open_galery, .slider_u_produktu img').click(function ()
  {
    if ($('body').width() > 1000)
    {
      var aktual_slide = slider_bx.getCurrentSlide();
    } else
      var aktual_slide = 0;

    $('body').css('overflow', 'hidden');
    $("#obr_galerie-li").dialog({
      resizable: true,
      height: $(window).height() - ($(window).height() * 0.3),
      width: $(window).width() - ($(window).width() * 0.2),
      modal: true,
      closeText: "",
      beforeClose: function () {
        $('body').css('overflow', '');
      },
      buttons: {
        "Zavřít": function () {
          $('body').css('overflow', '');
          $(this).dialog("close");
        }
      }
    });
   slider_li.reloadSlider();

  });
    $('.obr_galerie .fotka').click(function ()
  {
    if ($(this).attr('data-slide'))
    {
      var aktual_slide = $(this).attr('data-slide');
      slider_bx.goToSlide(aktual_slide);
    }
  });

  $('.obr_galerie-li .fotka').click(function ()
  {
    if ($(this).attr('data-slide'))
    {
      var aktual_slide = $(this).attr('data-slide');
      slider_li.goToSlide(aktual_slide);
      
    }
  });
  */
  
  $('.varianty_office_vybery').click(function ()
  {
    if($('.varianty_office_ostatni').hasClass("open_varianty"))
    {
      $('.varianty_office_ostatni').removeClass("open_varianty");
      $('.varianty_office').removeClass("open_varianty_celek");
    }
    else
    {
      $('.varianty_office_ostatni').addClass("open_varianty");
      $('.varianty_office').addClass("open_varianty_celek");
    }
});
  $(".varianty_office_ostatni").mouseleave(function () {
    
    $('.varianty_office_ostatni').removeClass("open_varianty");
      $('.varianty_office').removeClass("open_varianty_celek");
  });
  
  $(".recenze_ovladani").mousemove(function(e){
      var parentOffset = $(this).offset();
      var relX = e.pageX - parentOffset.left;
      var hodnoceni_celek = $(this).width();
      var hodnoceni_poloviny = hodnoceni_celek/5;
      var zvezdy = (relX/hodnoceni_poloviny).toFixed(0);
      $(".recenze_stars div").css('width', zvezdy*hodnoceni_poloviny);
      $("#hodnoceni_hodnota").val(zvezdy);
   });
   if($("#hodnoceni_hodnota").val() != '')
   {
      var hodnoceni_celek = $(".recenze_ovladani").width();
      var hodnoceni_poloviny = hodnoceni_celek/5;
      var zvezdy = $("#hodnoceni_hodnota").val(); 
      $(".recenze_stars div").css('width', zvezdy*hodnoceni_poloviny);
//      $("#hodnoceni_hodnota").val((zvezdy/2).toFixed(1));
   }
   
   if($(".produkt_hodnoceni_tab").is(":visible"))
   {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".produkt_hodnoceni_tab").offset().top-200
    }, 200);
   } 
   var hash = window.location.hash;
   if (hash.indexOf("comm") >= 0)   
   {
     $('*[data-show="produkt_hodnoceni_tab"]').click();
       $([document.documentElement, document.body]).animate({
        scrollTop: $(hash).offset().top-200
    }, 200);
   }

  $('.hodnoceni_radek').each(function( obj ) {

     if($(this).attr('data-pocet')!=='')
     {  

       var pomer = (parseFloat($(this).attr('data-pocet'))*100)/parseFloat($("#celkem_hod").val());
       
       $(this).children('.radek_posuvnik').children('div').css('width', pomer+'%');
     }
  });
   
  //zde ohlídám zobrazování malé ceny, pokud není vidět velká
  $(window).on('load resize scroll', function() {
    if( $( ".eshop_udaje_cena_viewport" ).length > 0 )
    {  
      if ($('#cena i').isInViewport_new()) {
          $( ".eshop_udaje_cena_viewport" ).addClass( "hidden" );
      } else {
          $( ".eshop_udaje_cena_viewport" ).removeClass( "hidden" );
      }
    }
    
    if( $( "#eshop_obrazek_produkt" ).length > 0 )
    {   
      if ($('#fotogalerie_view').isInViewport_new( 60 )) {
          $( "#eshop_obrazek_produkt .fotogalerie" ).removeClass( "posun_top" );
      } 
      if ( !$('#eshop_obrazek_produkt .fotogalerie').isInViewport_new( 60 ) ) {
          $( "#eshop_obrazek_produkt .fotogalerie" ).addClass( "posun_top" );
      }
    }
  });
  
  if(window.location.hash) {
    var hash = window.location.hash;
    hash = hash.replace("#", ""); 
    var e = $(".informace_vybery [data-url='"+hash+"']");
    if( e.length <= 0 ) e = $(".informace_vybery [data-url-old='"+hash+"']");
    if( e.length > 0 )
    {
      e.click(); 
      if( e.attr( "data-location" ) !== "" && e.attr( "data-location" ) !== undefined )
      {
        $([document.documentElement, document.body]).animate({
            scrollTop: $( '#hod' + e.attr( "data-location" ) ).offset().top
        }, 200);
      }
      //odkaz na konkrétní komentář poradny (?kom=ID)
      var kom = new URLSearchParams( window.location.search ).get( "kom" );
      if( kom && e.attr( "data-show" ) === "produkt_komentare_tab" ) zobrazKomentar( kom );
    }
    else  
      $('*[data-show="produkt_popis_tab"]').click();   
  } 
  $( "#dalsi_prislusenstvi" ).click( function() { $('*[data-show="produkt_prislusko_tab"]').click(); return false; } );
  
  //odpočet akce
  if( $( '.eshop_udaje_cena_akce_odpocet span' ).length > 0 ) //<p> přidat class hidden a <span>2022-07-26 18:54:59</span>
  {   
    //načte datum a čas
    var datum_cas  = new Date( $( '.eshop_udaje_cena_akce_odpocet' ).attr( "data-datum" ) ).getTime();  
    var preklady = $( '.eshop_udaje_cena_akce_odpocet' ).attr( "data-preklad" ).split( "," ); 

    var x = setInterval(function() { 
      if( $("#cena del").length <= 0 ){ $( '.eshop_udaje_cena_akce_odpocet' ).hide(); return false; }
      var now = new Date().getTime();
 
      var rozdil_time = datum_cas - now;
 
      var days = Math.floor(rozdil_time / (1000 * 60 * 60 * 24));
      var hours = Math.floor( (rozdil_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));// + ( days * 24 )
      var minutes = Math.floor((rozdil_time % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((rozdil_time % (1000 * 60)) / 1000);
      
      if ( !$('.eshop_udaje_cena_akce_odpocet').hasClass('extra') )
      {
        var preklad_den = preklady[0];
        if( days > 1 && days < 5 ) preklad_den = preklady[1];
        else if( days >= 5 ) preklad_den = preklady[2]; 

        $( '.eshop_udaje_cena_akce_odpocet span' ).html( ( days > 0 ? days + preklad_den + " " : "" ) + hours + preklady[3] + " " + ( (minutes < 10) ? '0'+minutes : minutes ) + preklady[4] + " " + ( (seconds < 10) ? '0'+seconds : seconds ) + preklady[5] ); 
      }
      
      $( '.eshop_udaje_cena_akce_odpocet' ).css( "display", "block" );

      //pokud někdo nechá načtený web a vyprší interval, tak se lišta skryje
      if ( rozdil_time < 0 ) {
        clearInterval(x);
        $( '.eshop_udaje_cena_akce_odpocet' ).hide();
      }
    }, 1000);//po 1 sekundě
  }
   
//    $(document).on('click', '.foto_galerie_span .fotka', function ()
//    {//způsobilo, když se procházelo v galerii, že to změnilo obrázek ve slideru
//      if ($(this).attr('data-slide'))
//      {
//        var aktual_slide = $(this).attr('data-slide');
//        if (slider_bx_sluzby)slider_bx_sluzby.goToSlide(aktual_slide);
//      }
//    });
    
    //delegovaně, aby fungovalo i pro donačtená hodnocení
    $( document ).on( "click", ".originalLang", function() {
      var text = $( this ).text();
      $( this ).text( $( this ).attr( "data-text" ) ).attr( "data-text", text );
      
      if( $( ".prekladLang_" + $( this ).attr( "data-id" ) ).hasClass( "hidden" ) )
      {
        $( ".prekladLang_" + $( this ).attr( "data-id" ) ).removeClass( "hidden" );
        $( ".origLang_" + $( this ).attr( "data-id" ) ).addClass( "hidden" );
      }
      else
      {
        $( ".prekladLang_" + $( this ).attr( "data-id" ) ).addClass( "hidden" );
        $( ".origLang_" + $( this ).attr( "data-id" ) ).removeClass( "hidden" );
      }
    });
    
    var slider_bx_sluzby = null;
    $( '.sluzba_zjisti_vice' ).click(function()
    {
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      $( 'div#sluzba_popis_' + $( this ).attr( "data-id" ) ).dialog({
        width: ( windowWidth <= 600 ? windowWidth - 50 : "60%" ),  
        height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.7 ),
        modal: true,
        resizable: true,
        dialogClass: "dialog_konfigurator",
        open: function () {
          openDialogScroll();
        },
        close: function () {
          closeDialogScroll();
        },
        beforeClose: function () {
          if (slider_bx_sluzby)
              slider_bx_sluzby.destroySlider();
        },
        buttons: {
          Close: function() { 
            $( this ).dialog( "close" );
          }
        }
      });

      if( $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).length > 0 )
      {
        slider_bx_sluzby = $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).bxSlider({
          mode: 'fade',
          speed: 0,
          infiniteLoop: true,
          controls: true,
          touchEnabled: false
        });
        slider_bx_sluzby.reloadSlider();
      }
      return false;
    });
    
    
    $( '.svaz-produkt' ).click(function (e) 
    {

        // klik na odkaz / tlačítko / obrázek
        if ($(e.target).closest('.js-ignore-click').length) return;

        // klik přímo na checkbox
        if ($(e.target).is('input[type="checkbox"]')) return;

        const $checkbox = $(this).find('.svaz-produkt-checkbox');
        const checked = !$checkbox.prop('checked');

        $checkbox.prop('checked', checked);
        $(this).toggleClass('selected', checked);
    });
 
  //swiper pro svázané produkty
  (() => {
          const container = document.querySelector('.bundle-cards');
          const btnLeft = document.querySelector('.bundle-arrow.left');
          const btnRight = document.querySelector('.bundle-arrow.right');

          if (!container || !btnLeft || !btnRight) return;

          const getGap = () => {
            const cs = getComputedStyle(container);
            const gap = parseFloat(cs.columnGap || cs.gap || '0');
            return Number.isFinite(gap) ? gap : 0;
          };

          const getStep = () => {
            // vezmeme první kartu jako referenci
            const card = container.querySelector('.bundle-card');
            if (!card) return container.clientWidth; // fallback

            return card.getBoundingClientRect().width + getGap();
          };

          const updateArrows = () => {
            const maxScroll = container.scrollWidth - container.clientWidth;

            // tolerance kvůli floatům a subpixelům
            const eps = 2;

            btnLeft.disabled = container.scrollLeft <= eps;
            btnRight.disabled = container.scrollLeft >= (maxScroll - eps) || maxScroll <= 0;
          };

          const scrollByStep = (dir) => {
            container.scrollBy({ left: dir * getStep(), behavior: 'smooth' });

            // po kliknutí se scrollLeft změní až "za chvíli", tak aktualizujeme i se zpožděním
            requestAnimationFrame(updateArrows);
            setTimeout(updateArrows, 200);
            setTimeout(updateArrows, 450);
          };

          btnLeft.addEventListener('click', (e) => {
            e.preventDefault();
            scrollByStep(-1);
          });

          btnRight.addEventListener('click', (e) => {
            e.preventDefault();
            scrollByStep(1);
          });

          container.addEventListener('scroll', () => {
            // pasivní update při ručním scrollu
            updateArrows();
          }, { passive: true });

          window.addEventListener('resize', updateArrows);

          // init
          updateArrows();
    })();

    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                loadSocialProof($(entry.target));
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: '600px',
        threshold: 0
    });

    $('.eshop_produkt_clanek').each(function() {
        observer.observe(this);
    });
    function loadSocialProof($container) {
      var id = $container.data('id');
      $.get(root + "/rsadmin/_funkce/load_clanek.php", { id: id, typ: "clanek_produkt" })
          .done(function(response) {
              var elements = $.parseHTML(response, document, true);
              $container.empty().append(elements);
              $container.find('a > img').parent().css({'border-bottom': 'none'});
          })
          .fail(function(xhr, status, error) {
              console.error('no load data', error);
          });
    }
     
}); 
  
function KontrolaFormular()
{
  var chyby = 0;
  $('#emailGarance .chyba_req').hide();
  $.each( $('#emailGarance .req'), function( key, value )
  {   
     $( value ).removeAttr('style');
    if($( value ).attr('name') === 'emailGarance_email')
    {
      if( $( value ).val().match(/^[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+@[-!#$%&\'*+\\/0-9=?A-Z^_`a-z{|}~]+\.[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+$/))
      {
        $( value ).removeAttr('style');
      }
      else
      {
        $( value ).css('border-color','red');
        $( value ).parent().parent().find('.chyba_req').show();
        chyby++;
      }
    }
    else if($( value ).attr('name') === 'emailGarance_odkaz')
    {
      if(!isUrlValid($( value ).val()))
      {
        $( value ).css('border-color','red');
        $( value ).parent().parent().find('.chyba_req').show();
        chyby++;
      }
      else
      {
        $( value ).removeAttr('style');
      }
    }
    else if($( value ).attr('name') === 'emailGarance_telefon')
    {
      if($( value ).val().length > 0)
      {      
         if($( value ).val().length >= 9)
         { 
           $( value ).removeAttr('style');
         }
         else
         {
           $( value ).css('border-color','red');
           $( value ).parent().parent().find('.chyba_req').show();
           chyby++;
         }
      }
    }
    else if($( value ).attr('name') === 'simpleCaptchaRes')
    { 
      if($( value ).val().length > 0)
      {   
        $( value ).removeAttr('style'); 
      }
      else
      {
        $( value ).css('border-color','red');
        //$( value ).parent().parent().find('.chyba_req').show();
        chyby++;
      }
    }
    else if($( value ).val().length === 0 || $( value ).val() === 0)
    {
      $( value ).css('border-color','red');
      $( value ).parent().parent().find('.chyba_req').show();
      chyby++;
    }
    else
    {
     $( value ).removeAttr('style');
    }
  });

  if(chyby === 0) return true;
  else return false; 
}
function isUrlValid(url) {
   var urlregex = new RegExp(
        "^(http:\/\/www.|http:\/\/|https:\/\/www.|https:\/\/|www.){1}([0-9A-Za-z]+\.)");
  return urlregex.test(url);
}


function ZobrHodnoceni(){  
  var e=$(".informace_vybery [data-show='produkt_hodnoceni_tab']");
  if(e.length>0)e.click();
  if(e.length>0)return void $("html, body").animate({scrollTop:e.offset().top-200},100);
}